import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-bb-self-guided-intro',
    templateUrl: './bb-self-guided-intro.component.html',
    styleUrls: ['./bb-self-guided-intro.component.scss'],
    standalone: false
})
export class BbSelfGuidedIntroComponent implements OnInit {
  translations: Record<string, string> = {};

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.getTranslation().subscribe({
      next: (translations) => {
        this.translations = translations;
      }
    });
  }
}
